import PropTypes from 'prop-types';
import React from 'react';

import SwapUserIcon from '../../../assets/img/SwapUserIcon';
import { USERS_ACTIONS } from '../../store/actions/reducer-actions/users';
import { Colors } from '../../styles/vars';
import { connect } from '../../utils/redux';
import Button from './Button';

const MultiAccountSwitch = ({ currentUser, setMultiAccountCurrentUser }) => {
  const resetMultiAccountCurrentUser = () => {
    setMultiAccountCurrentUser(null);
  };

  return (
    currentUser.isMultiAccount && (
      <Button
        type="button"
        color={Colors.black}
        background={Colors.pureWhite}
        hoverColor={Colors.black}
        hoverBackground={Colors.white}
        onClick={resetMultiAccountCurrentUser}
      >
        <SwapUserIcon />
        <span>Changer de compte actif</span>
      </Button>
    )
  );
};

MultiAccountSwitch.propTypes = {
  currentUser: PropTypes.objectOf(PropTypes.any),
  setMultiAccountCurrentUser: PropTypes.func.isRequired,
};

MultiAccountSwitch.defaultProps = {
  currentUser: null,
};

export default connect(state => ({ ...state.users }), {
  ...USERS_ACTIONS,
})(MultiAccountSwitch);
